import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import Shimmer from "components/ui/shimmer"
import { isTestMode } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const InternalBreadcrumb = ({
  breadcrumb_array,
  pdpPricingHierarchyExp,
  wizardLoading,
}) => {
  const { isMobile } = useWindowDimensions()

  const handleBreadcrumbClick = () => {
    if (!isTestMode && isMobile) {
      dataLayer.push({
        event: "clicked-breadcrumbs-pdp",
      })
    }
  }
  if (wizardLoading) {
    return pdpPricingHierarchyExp === 1 ? (
      <Shimmer className="mb-8 h-14" style={{ width: "160px" }} />
    ) : (
      <Shimmer
        className="h-(--base-height) tablet:h-(--tablet-height) mb-8"
        style={{
          "--base-height": "14px",
          "--tablet-height": "16px",
          width: "160px",
        }}
      />
    )
  }
  return (
    <nav aria-label="Breadcrumb" className="mb-8">
      <ol
        className={cn(
          pdpPricingHierarchyExp === 1
            ? "text-grey-400 text-12 leading-14 list-none font-medium"
            : "tablet:text-grey-500 text-12 tablet:text-14 tablet:font-medium leading-14 tablet:leading-16 list-none font-semibold text-black"
        )}
      >
        {breadcrumb_array.map((breadcrumb, i) => (
          <li
            className={cn(
              "inline",
              i === breadcrumb_array.length - 1 &&
                pdpPricingHierarchyExp === 0 &&
                "text-grey-400 tablet:text-grey-500",
              i > 0 && "before:px-4 before:content-['/']"
            )}
            key={`breadcrumb-${breadcrumb.name}`}
          >
            <Link
              data-lc="breadcrumb"
              onClick={handleBreadcrumbClick}
              to={breadcrumb.url}
            >
              {breadcrumb.name}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}

const mapStateToProps = (state) => {
  return {
    breadcrumb_array: state.wizard.description.breadcrumb || [],
    pdpPricingHierarchyExp: state.experiment.pdpPricingHierarchy.variant_id,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => ({})

InternalBreadcrumb.propTypes = {
  breadcrumb_array: PropTypes.array,
  pdpPricingHierarchyExp: PropTypes.number,
  wizardLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

const Breadcrumb = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalBreadcrumb)

export default Breadcrumb
